import { CartPicker } from './styles'

export default CartPicker
